import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const Cancel = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: ['80px', '80px', '110px', '110px'],
    height: ['56px', '56px', 'auto', 'auto'],
    color: defaultTheme.text.gray,
    fontSize: [
      defaultTheme.font.size.l,
      defaultTheme.font.size.l,
      defaultTheme.font.size.xl,
      defaultTheme.font.size.xl,
    ],
    fontWeight: 'bold',
    textAlign: 'center',
    backgroundColor: defaultTheme.background.mediumGray,
    border: `2px solid ${defaultTheme.border.color.mediumGray}`,
    borderRadius: defaultTheme.border.radius.l,
    padding: `${defaultTheme.spacing.xxl} 0`,
  }),
);

export const NotReleaseText = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: ['80px', '80px', '110px', '110px'],
    height: ['56px', '56px', 'auto', 'auto'],
    color: defaultTheme.text.default,
    fontSize: defaultTheme.font.size.xl,
    fontWeight: 'bold',
    backgroundColor: defaultTheme.background.white,
  }),
);

export const ResultLink = styled(Cancel)(() =>
  mq({
    color: defaultTheme.color.primary,
    backgroundColor: defaultTheme.background.white,
    borderColor: defaultTheme.border.color.primary,
    ...hoverOpacity,
  }),
).withComponent(Link);

export const BetLink = styled(ResultLink)(() =>
  mq({
    color: defaultTheme.text.white,
    backgroundColor: defaultTheme.background.primary,
    ...hoverOpacity,
  }),
);
